import { ChevronRightIcon } from "@heroicons/react/24/solid";
import React from "react";
import { Link } from "react-router-dom";
import CoreTeam1 from "../../assets/images/red-coreteam.png"
import CoreTeam2 from "../../assets/images/yellow-coreteam.png"
import CoreTeam3 from "../../assets/images/green-coreteam.png"

export default function AboutPageCoreTeamSection() {
  return (
    <div id="coreteam" className="w-11/12 md:w-8/12 py-16 text-sky-800 dark:text-sky-500">
      <div className="flex items-center w-full justify-between">
        <h1 className="text-2xl md:text-3xl font-semibold ">Core Teams</h1>
      </div>
      <div className="grid gap-7 lg:grid-cols-3 mt-10">
           <Link
          to="/team/2023"
          className="items-center dark:text-sky-300 cursor-pointer dark:hover:text-white"
        >
        <Card
          title="Team 2022 - 2023"
          coverImg={CoreTeam1}
        />
        </Link>
        <Link
          to="/team/2022"
          className="items-center dark:text-sky-300 cursor-pointer dark:hover:text-white"
        >
        <Card
          title="Team 2021 - 2022"
          coverImg={CoreTeam2}
        />
        </Link>
        <Link
          to="/team/2021"
          className="items-center dark:text-sky-300 cursor-pointer dark:hover:text-white"
        >
        <Card
          title="Team 2020 - 2021"
          coverImg={CoreTeam3}
        />
        </Link>
      </div>
    </div>
  );
}

function Card({ coverImg, title, dp, volume, floorPrice }) {
  return (
    <div className="shadow-md dark:bg-gray-900 rounded-2xl flex items-center flex-col hover:shadow-2xl cursor-pointer transition-all">
      <div
        style={{
          backgroundImage: `url(${coverImg})`,
        }}
        className="w-full bg-cover bg-center h-44 relative rounded-t-2xl"
      ></div>
      <h1 className="p-5 font-semibold text-lg">{title}</h1>
    </div>
  );
}
